import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageService } from 'src/app/services/account/language.service';
import { SettingsService } from 'src/app/services/account/settings.service';
import { ECarType } from 'src/app/models/ecar-type';
import { ValueIntegerPipe } from 'src/app/pipes/value-integer.pipe';
import { EvSliderComponent } from '../../../ui-components/ev-slider/ev-slider.component';
import { ModalOptionPanelComponent } from '../../modal-option-panel/modal-option-panel.component';

export type ChargingPage =
  | { page: 'stations', mode: 'favorite' | 'disabled' }
  | { page: 'operators', mode: 'prefer' | 'avoid' };

@Component({
  standalone: true,
  selector: 'app-charging-options',
  templateUrl: './charging-options.component.html',
  styleUrls: ['./charging-options.component.scss'],
  imports: [CommonModule, EvSliderComponent, ValueIntegerPipe, ModalOptionPanelComponent]
})
export class ChargingOptionsComponent {
  @Input() selectedCar: ECarType | null = null;
  @Input() fastChargeLimit: number = 90;
  @Input() fastChargeLimitMin: number = 75;
  @Input() fastChargeLimitMax: number = 90;
  @Input() batteryStateOfHealth: number = 100;
  @Input() batteryStateOfHealthMin: number = 50;
  @Input() batteryStateOfHealthMax: number = 110;
  @Input() selectedChargerTypes: boolean[] = [false, false, false, false, false, false];
  @Input() chargerTypes: { name: string, icon: string }[] = [];

  @Output() fastChargeLimitChange = new EventEmitter<number>();
  @Output() batteryStateOfHealthChange = new EventEmitter<number>();
  /** Emits the full new selection — the input array is never mutated in place. */
  @Output() chargerTypesChange = new EventEmitter<boolean[]>();
  /** Asks the parent dialog to open one of the charging station/operator pages. */
  @Output() openChargingPage = new EventEmitter<ChargingPage>();

  constructor(
    public languageService: LanguageService,
    public settingsService: SettingsService
  ) {}

  public get favoriteStationCount(): number {
    return this.settingsService.getFavoriteChargingStationIds()?.length || 0;
  }
  public get disabledStationCount(): number {
    return this.settingsService.getDisabledChargingStationIds()?.length || 0;
  }
  public get favoriteOperatorCount(): number {
    return this.settingsService.getFavoriteChargingOperatorIds()?.length || 0;
  }
  public get disabledOperatorCount(): number {
    return this.settingsService.getDisabledChargingOperatorIds()?.length || 0;
  }

  public toggleChargerType(i: number): void {
    this.chargerTypesChange.emit(this.selectedChargerTypes.map((selected, index) => index === i ? !selected : selected));
  }
}
